import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, palette, spacing }) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: spacing(3, 15.75, 0, 15.75),
  },
  containerX: {
    [breakpoints.up('sm')]: {
      marginTop: '30px',
    },
  },
  confirmButton: {
    backgroundColor: palette.green.dark,
    color: palette.white.main,
    width: spacing(15),
    margin: spacing(2),
    marginRight: spacing(0),
    letterSpacing: '0px',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: palette.green.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      marginTop: spacing(1),
      margin: spacing(0),
    },
    '@media (max-width:375px)': {
      marginTop: spacing(1),
    },
    '@media (max-width:320px)': {
      marginTop: spacing(1),
    },
  },
  rootText: {
    margin: spacing(3, 15.75, 0, 15.75),
    fontSize: spacing(6),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
  },
  subTitle: {
    margin: spacing(1),
    fontSize: spacing(3),
    fontWeight: spacing(50),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    // width: '800px',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.75),
      margin: spacing(2),
    },
    '@media (max-width:375px)': {
      fontSize: spacing(1.5),
    },
    '@media (max-width:320px)': {
      fontSize: spacing(1.5),
    },
  },
  hlsPlayer: {
    width: '800px',
    [breakpoints.down('sm')]: {
      width: '400px',
    },
    '@media (max-width:375px)': {
      width: '330px',
    },
    '@media (max-width:320px)': {
      width: '280px',
    },
  },
  slider: {
    [breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  backButton: {
    // // backgroundColor: palette.green.dark,
    // color: palette.green.main,
    // border: `2px solid ${palette.green.dark}`,
    // width: spacing(15),
    // margin: spacing(2),
    // letterSpacing: '0px',
    // textTransform: 'unset',
    // '&:hover': {
    //   backgroundColor: palette.white.dark,
    // },
    // marginTop: spacing(1),
    color: palette.green.main,
    border: `2px solid ${palette.green.dark}`,
    width: spacing(15),
    margin: spacing(2),
    letterSpacing: '0px',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: palette.white.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
      margin: spacing(1, 0),
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '800px',
    // [breakpoints.only('lg')]: {
    //   width: '650px',
    // },
    [breakpoints.down('sm')]: {
      width: '400px',
      flexDirection: 'column-reverse',
      padding: spacing(1, 0),
    },
    '@media (max-width:375px)': {
      // padding: spacing(2.5),
      padding: spacing(1, 4, 1, 4),
    },
    '@media (max-width:320px)': {
      padding: spacing(1, 4, 1, 4),
    },
  },
  logoContainer: {
    [breakpoints.down('sm')]: {
      // height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
  },
}));
